import React from "react";
import { theme } from "@/styles/theme";
import { ScrollArea } from "@/components/ScrollArea";

type AboutPanelProps = {
  imageSrc?: string;
  imageAlt?: string;
};

export function AboutPanel({ imageSrc, imageAlt }: AboutPanelProps) {
  return (
    // OUTER: beveled frame, no scrolling here
    <div
      style={{
        background: theme.colors.DarkGray,
        boxShadow:
          "-1px -1px 0 0 #ffffff inset, 1px 1px 0 0 #808080 inset, -2px -2px 0 0 #c1c1c1 inset, 2px 2px 0 0 #000000 inset",
        padding: 16, // gap between bevel and inner panel
        flex: 1,
        alignSelf: "stretch",
        boxSizing: "border-box",
        overflow: "hidden", // scrolling happens only inside ScrollArea
        display: "flex",
        minHeight: 0,
      }}
    >
      <ScrollArea
        style={{
          flex: 1,
          minHeight: 0,
        }}
        contentStyle={{
          padding: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 4,
          color: theme.colors.White,
          fontFamily: theme.fonts.body,
          fontSize: 18,
          lineHeight: 1.4,
        }}
      >
        {imageSrc && (
          <img
            src={imageSrc}
            alt={imageAlt ?? "About image"}
            style={{
              marginBottom: 18,
              maxWidth: "100%",
              height: "auto",
              imageRendering: "pixelated",
              display: "block",
            }}
          />
        )}

        <p style={{ margin: 0 }}>
          We are Bula and Ale Barredo, brothers from Argentina making video
          games, <span style={{ color: theme.colors.Green, }} > THE PUZZLE BROS </span>. 
          While we continue learning and developing independently
          we incorporated our studio at the end of 2021.
        </p>
        <p style={{ margin: 0 }}>
          We make our own games and also collaborate with other studios and
          creators to bring their ideas to life, focusing on quality and
          innovation.
        </p>

        <p style={{ margin: 0, marginTop: 8 }}>
          This space will evolve as projects grow: devlogs, prototypes, and odd
          experiments that don&apos;t fit anywhere else.
        </p>
      </ScrollArea>
    </div>
  );
}
